import { Provider } from "react-redux";
import { store } from "./context/store/store";

import { BrowserRouter } from "react-router-dom";
import { AppRouter } from "./routes/ApppRoute";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
